import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';

export class StartImportCatalog implements LoadingAction {
  readonly type = actions.START_IMPORT_CATALOG;
  readonly isLoading = false;

  constructor(public artistId: string) {}
}

export class TrackImportProgress implements LoadingAction {
  readonly type = actions.TRACK_IMPORT_PROGRESS;
  readonly isLoading = false;

  constructor(public artistId: string, public retry: number) {}
}

export class TrackImportProgressError implements ErrorAction {
  readonly type = actions.TRACK_IMPORT_PROGRESS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class TrackImportProgressSuccess implements LoadingAction {
  readonly type = actions.TRACK_IMPORT_PROGRESS_SUCCESS;
  readonly isLoading = false;

  constructor(public artistId: string, public progress: number) {}
}

export class ImportCatalogSuccess implements LoadingAction {
  readonly type = actions.IMPORT_CATALOG_SUCCESS;
  readonly isLoading = false;

  constructor(public artistId: string) {}
}

export class ImportCatalogError implements ErrorAction {
  readonly type = actions.IMPORT_CATALOG_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type ImportCatalogActions =
  | StartImportCatalog
  | TrackImportProgress
  | TrackImportProgressSuccess
  | TrackImportProgressError
  | ImportCatalogSuccess
  | ImportCatalogError;
